import {
  legacy_createStore,
  compose,
  applyMiddleware,
  combineReducers,
  Reducer,
  UnknownAction,
  Action,
} from 'redux';
import { thunk, ThunkDispatch } from 'redux-thunk';
import { AuthState, reducer as auth } from './auth';
import { ConfigState, reducer as config } from './config';
import { ConsentsState, reducer as consents } from './consents';
import { eventsMiddleware } from './middleware/events';
import { persist, loadState } from './middleware/persist';
import { scroller } from './middleware/scroller';
import { tracker } from './middleware/tracker';

export const RESET = 'RESET';

export type RootState = {
  auth: AuthState;
  config: ConfigState;
  consents: ConsentsState;
  globalOfferId: string;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const appReducer: Reducer<RootState> = combineReducers({
  config,
  auth,
  consents,
});

const rootReducer = (
  state: RootState,
  action: UnknownAction,
) => {
  const startState = action.type === RESET ? loadState() : state;
  return appReducer(startState, action);
};

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = legacy_createStore<RootState, UnknownAction, {
  dispatch: ThunkDispatch<RootState, void, Action>
  // @ts-expect-error quick and dirty ts fix
}, unknown>(
  rootReducer,
  undefined,
  composeEnhancers(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    applyMiddleware(thunk, persist, eventsMiddleware, tracker, scroller),
  ),
);

export type AppDispatch = typeof store.dispatch;
